import { Box } from '@mui/material';
import {
    DocumentPlus,
    EmployeesIcon,
    IconBuildingTable,
    DocumentationIcon,
    IconEntryDevice,
    IconEquipmentMaterial,
    IconHistory,
    IconVehicle,
    PersonBook, IconCustomAccess,
} from '../../../../components/buttons/IconButtons';
import { CustomStyleIconCircleContainer } from '../../../../components/Styles';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import { permissionObj } from '../../../../Helpers/permission';
import EmployeeSection from '../SubComponents/EmployeeSection';
import VehicleSection from '../SubComponents/VehicleSection';
import EquipmentMaterialSection from '../SubComponents/EquipmentMaterialSection';
import AccessRightsSection from '../SubComponents/AccessRightsSection';
import { DEVICE_ACCESS_TYPE_MODEL } from '../../Devices/Model/Model';
import { colors } from '../../../../enums/colors';
import {getFieldTypeById} from "../../Visitor/Type/Model/Model";
import {FILE_MODEL} from "../../Visitor/Visitor/Model/Model";
import CompanySection from "../SubComponents/ContractorDetailsFlows/CompanySection";
import {PROFILE_MODEL} from "../../../DocumentationApprovalFlow/Model/Model";
import {TABLES} from "../../../../Apis/Tables";
import AccessLog from '../../../Contractor/Contracts/SubComponents/EmployeeDetailsFlows/AccessLog/AccessLog';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import React from 'react';
import {SEARCH_MODEL} from '../../../../components/table/Model/TableModel';
import {USER_TYPE_MODEL} from '../../../../enums/userTypeEnum';
import { getAllUserAccessLogByUserId, getAllVehicleAccessLogByVehicleId } from '../../../../reduxToolkit/Logs/LogApi';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

export const FREQUENCY_VALUE_FIELD_NAME = "frequencyValue";
export const TIME_UNIT_FIELD_NAME = "timeUnit";
export const RENEWAL_FIELD_NAME = "renewal";
export const START_DATE_FIELD_NAME = "startDate";

export const CONTRACTORS_SUBVIEW_MODEL = {
    DOCUMENTATION: {
        APPROVAL_FLOW:"APPROVAL_FLOW",
        REQUESTS:"REQUESTS"
    }
}

export const TABS_CONTRACTORS = {
    CONTRACTS: {
        INDEX: 0,
        TRANS: "contracts",
    },
    CONTRACTORS: {
        INDEX: 1,
        TRANS: "contractors",
    },
    MANAGE: {
        INDEX: 2,
        TRANS: "manage",
    },
    DOCUMENTATION: {
        INDEX: 3,
        TRANS: "documentation"
    }
}

export const STEPS_CONTRACTOR_CREATE = {
    COMPANY_DETAILS:0,
    MANAGER_DETAILS:1,
    OTHER_DETAILS:2,
    ADD_PHOTO:3,
    ACCESS_RIGHT: 4,
    SUMMARY: 5
}
export const STEPS_CONTRACTOR_CREATE_NO_DETAILS = {
    COMPANY_DETAILS:0,
    MANAGER_DETAILS:1,
    ADD_PHOTO:2,
    ACCESS_RIGHT: 3,
    SUMMARY: 4
}

export const STEPS_CONTRACTOR_UPDATE = {
    COMPANY_DETAILS:0,
    MANAGER_DETAILS:1,
    OTHER_DETAILS:2,
    ADD_PHOTO:3,
    ACCESS_RIGHT: 4
}
export const STEPS_CONTRACTOR_UPDATE_NO_DETAILS = {
    COMPANY_DETAILS:0,
    MANAGER_DETAILS:1,
    ADD_PHOTO:2,
    ACCESS_RIGHT: 3
}

/**
 * Centralized permission manager for Contractors module.
 * It evaluates permissions depending on the current tab,
 * subView, and the presence of contractorId.
 *
 * @param {string} subView - Active subview identifier (Approval Level, Request, etc.)
 * @param {number|null} contractorId - Current contractor ID (null if not selected)
 * @param {Array<string>} permission - List of user permissions
 * @returns {object} Action-permission mapping already evaluated
 */
export function TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV) {
    const restricted = [
        ACTION_MODEL.CREATE,
        ACTION_MODEL.DELETE,
        ACTION_MODEL.IMPORT
    ];

    // Helper: validates if an action is allowed
    const check = (action, required) => {
        if (DEV) return true;
        if (!required) return false;
        if (restricted.includes(action) && contractorId !== null) return false;
        return permission?.includes(required);
    };

    return {
        [ACTION_MODEL.CREATE]: {
            [TABS_CONTRACTORS.CONTRACTS.INDEX]: check(ACTION_MODEL.CREATE, permissionObj?.WEB_CONTRACTOR_CONTRACT_CREATE),
            [TABS_CONTRACTORS.CONTRACTORS.INDEX]: check(ACTION_MODEL.CREATE, permissionObj?.WEB_CONTRACTOR_CREATE),
            [TABS_CONTRACTORS.DOCUMENTATION.INDEX]: check(
                ACTION_MODEL.CREATE,
                subView === CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW
                    ? permissionObj?.WEB_CONTRACTOR_APPROVAL_FLOW_CREATE
                    : null
            ),
        },
        [ACTION_MODEL.DELETE]: {
            [TABS_CONTRACTORS.CONTRACTS.INDEX]: check(ACTION_MODEL.DELETE, permissionObj?.WEB_CONTRACTOR_CONTRACT_DELETE),
            [TABS_CONTRACTORS.CONTRACTORS.INDEX]: check(ACTION_MODEL.DELETE, permissionObj?.WEB_CONTRACTOR_DELETE),
            [TABS_CONTRACTORS.DOCUMENTATION.INDEX]: check(
                ACTION_MODEL.DELETE,
                subView === CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW
                    ? permissionObj?.WEB_CONTRACTOR_APPROVAL_FLOW_DELETE
                    : null
            ),
        },
        [ACTION_MODEL.UPDATE]: {
            [TABS_CONTRACTORS.MANAGE.INDEX]: check(ACTION_MODEL.UPDATE, permissionObj?.WEB_CONTRACTOR_MANAGE_UPDATE)
        },
        [ACTION_MODEL.IMPORT]: {
            [TABS_CONTRACTORS.CONTRACTORS.INDEX]: check(ACTION_MODEL.IMPORT, permissionObj?.WEB_CONTRACTOR_IMPORT),
        },
        [ACTION_MODEL.EXPORT]: {
            [TABS_CONTRACTORS.CONTRACTS.INDEX]: check(ACTION_MODEL.EXPORT, permissionObj?.WEB_CONTRACTOR_CONTRACT_EXPORT),
            [TABS_CONTRACTORS.CONTRACTORS.INDEX]: check(ACTION_MODEL.EXPORT, permissionObj?.WEB_CONTRACTOR_EXPORT),
        },
        [ACTION_MODEL.ADVANCE_SEARCH]: {
            [TABS_CONTRACTORS.CONTRACTORS.INDEX]: check(ACTION_MODEL.ADVANCE_SEARCH, permissionObj?.WEB_CONTRACTOR_READ),
        }
    };
}

export const DOCUMENT_MODEL = {
    id: null,
    levelName: null,
    statusId: null,
    document: null,
    createdAt: null,
    levelType: null,
    fileUploadDto: null,
    toSet: function (data) {

        const type =  getFieldTypeById(data.levelType);
        return {
            ...this,
            id: data.id,
            levelName: data.levelName,
            statusId: data.statusId,
            document: data.document,
            createdAt: data.createdAt,
            levelType: type?.id,
            levelTypeTrans: type?.name,
            icon: type?.icon,
            fileUploadDto: data.fileUploadDto ? FILE_MODEL.set(data) : null
        }
    }
}

export const USER_LIST_MODEL = {
    id: null,
    name: null,
    updatedAt: null,
    statusId: null,
    toSet: function (data) {
        return {
            ...this,
            id: data.userId,
            name: data.fullName,
            updatedAt: data.updatedAt,
            statusId: data.statusId
        }
    }
}

export const VEHICLE_LIST_MODEL = {
    id: null,
    brand: '',
    subBrand: '',
    plate: '',
    updatedAt: null,
    statusId: null,
    toSet: function (data) {
        return {
            ...this,
            id: data.id,
            brand: data.brand,
            subBrand: data.subBrand,
            plate: data.plate,
            updatedAt: data.updatedAt,
            statusId: data.statusId
        }
    }
}

export const EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL = {
    ACCESS_LOG: {
        ID: 1,
        KEY: "access_log",
        LABEL:"access_log"
    },
    DOCUMENTATION: {
        ID: 2,
        KEY: "employee_documentation",
        LABEL: "employee_documentation"
    }
};

export const VEHICLE_DETAILS_PROVIDER_SECTION_MODEL = {
    ACCESS_LOG: {
        ID: 1,
        KEY: "access_log",
        LABEL:"access_log"
    },
    DOCUMENTATION: {
        ID: 2,
        KEY: "vehicle_documentation",
        LABEL: "vehicle_documentation"
    }
};

export const ACCESS_LOG_GET_DATA = {
    USER: {
        name: "USER",
        buildBody: ({ page, rowsPerPage, id, option }) => SEARCH_MODEL.setObject({ page: page, size: rowsPerPage, userId: id, model: option }),
        action: getAllUserAccessLogByUserId,
        txtNotInformation: 'you_dont_have_access_log_yet'
    },
    VEHICLE: {
        name: "VEHICLE",
        buildBody: ({ page, rowsPerPage, id, option }) => ({
            ...SEARCH_MODEL.setObject({ page, size: rowsPerPage, model: option }),
            vehicleId: id,
        }),
        action: getAllVehicleAccessLogByVehicleId,
        txtNotInformation: 'you_dont_have_access_log_yet'
    },
};


export const getSections = ({ userTypeId, userId, contractorId, workShiftsList, customizedList}) => [
    {
        id: 1,
        key: 'company',
        label: 'company_documentation',
        icon: <IconBuildingTable className='w-20px h-20px' />,
        content: () => <CompanySection
            noInformationTitle={'no_company_documentation'}
            userTypeId={userTypeId}
            userId={userId}
            profile={PROFILE_MODEL.COMPANY}
            historyModel={TABLES.HISTORY_CONTRACTOR_IN_CHARGE_DOCUMENTATION_LEVEL}
        />,
    },
    {
        id: 2,
        key: 'employee',
        label: 'employee_documentation',
        icon: <EmployeesIcon className='w-20px h-20px' />,
        content: () => <EmployeeSection
            noInformationTitle={'no_employee_documentation'}
            userTypeId={userTypeId}
            contractorId={contractorId}
            profile={PROFILE_MODEL.EMPLOYEE}
            model={TABLES.CONTRACTOR_EMPLOYEE_DOCUMENTATION_LEVEL}
            historyModel={TABLES.HISTORY_CONTRACTOR_EMPLOYEE_DOCUMENTATION_LEVEL}
        />
    },
    {
        id: 3,
        key: 'vehicle',
        label: 'vehicle_documentation',
        icon: <IconVehicle className='w-20px h-20px' />,
        content: () => <VehicleSection
            noInformationTitle={'no_vehicle_documentation'}
            userTypeId={userTypeId}
            contractorId={contractorId}
            profile={PROFILE_MODEL.VEHICLE}
            model={TABLES.CONTRACTOR_VEHICLE_DOCUMENTATION_LEVEL}
            historyModel={TABLES.HISTORY_CONTRACTOR_VEHICLE_DOCUMENTATION_LEVEL}
        />
    },
    {
        id: 4,
        key: 'equipment',
        label: 'equipment_material',
        icon: <IconEquipmentMaterial className='w-20px h-20px' />,
        content: () => <EquipmentMaterialSection
            contractorId={contractorId}
            model={TABLES.CONTRACTOR_VEHICLE_DOCUMENTATION_LEVEL}//Change model
        />,
    },
    {
        id: 5,
        key: 'access_right',
        label: 'access_rights',
        icon: <IconEntryDevice className='w-20px h-20px' />,
        content: () => <AccessRightsSection
            workShiftsList={workShiftsList}
            customizedList={customizedList}
        />,
    },
];

export const getSectionsEmployeeDetailsProvider = ({ userTypeId, userId, option}) => [
    {
        id: EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.DOCUMENTATION.ID,
        key: EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.DOCUMENTATION.KEY,
        label: EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.DOCUMENTATION.LABEL,
        icon: <IconBuildingTable className='w-20px h-20px' />,
        content: () => <CompanySection
            noInformationTitle={'no_employee_documentation'}
            userTypeId={userTypeId}
            userId={userId}
            profile={PROFILE_MODEL.EMPLOYEE}
            historyModel={userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE ? TABLES.HISTORY_CONTRACTOR_EMPLOYEE_DOCUMENTATION_LEVEL : TABLES.HISTORY_SUPPLIER_EMPLOYEE_DOCUMENTATION_LEVEL}
        />,
    },
    {
        id: EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.ID,
        key: EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.KEY,
        label: EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.LABEL,
        icon: <IconCustomAccess className='w-20px h-20px' />,
        content: () => <AccessLog
            id={userId}
            option={option}
            accessLogMode={ACCESS_LOG_GET_DATA.USER.name}
        />
    }
];

export const getSectionsVehicleDetailsProvider = ({ userTypeId, id, option}) => [
    {
        id: VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.DOCUMENTATION.ID,
        key: VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.DOCUMENTATION.KEY,
        label: VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.DOCUMENTATION.LABEL,
        icon: <IconBuildingTable className='w-20px h-20px' />,
        content: () => <CompanySection
            noInformationTitle={'no_vehicle_documentation'}
            userTypeId={userTypeId}
            userId={id}
            profile={PROFILE_MODEL.VEHICLE}
            historyModel={userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE ? TABLES.HISTORY_CONTRACTOR_VEHICLE_DOCUMENTATION_LEVEL : TABLES.HISTORY_SUPPLIER_VEHICLE_DOCUMENTATION_LEVEL }
        />,
    },
    {
        id: VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.ID,
        key: VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.KEY,
        label: VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.LABEL,
        icon: <IconCustomAccess className='w-20px h-20px' />,
        content: () => <AccessLog
            id={id}
            option={option}
            accessLogMode={ACCESS_LOG_GET_DATA.VEHICLE.name}
        />,
    }
];

export const getColumns = (t, className = '') => [
    {
        field: 'label',
        label: 'description',
        width: 'w-100',
        render: (val, row) => (
            <div className={`d-flex align-items-center gap-2 ${className}`}>
                <Box sx={CustomStyleIconCircleContainer}>{row.icon}</Box>
                <p className='fs-14px font-color-text-950 ibl-font-w-600 m-0'>{t(val)}</p>
            </div>
        ),
    },
];

export const getColumnsEmployeeDetailsProvider = (t, moduleId, option, id) => [
        ...getColumns(t, "my-3"),
    {
        field: 'label',
        label: '',
        className: 'w-100 d-flex align-items-center justify-content-end',
        render: (val, row) => {
            const body = SEARCH_MODEL.setObject({
                page:0,
                size: 20,
                model: option,
                userId: id,
            });
            return row.key === EMPLOYEE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.KEY &&
                <ExportDataBtn
                moduleId={moduleId}
                body={body}
                option={option}
                search={false}
                contractorSupplier={false}
            />;
        }},
];

export const getColumnsVehicleDetailsProvider = (t, moduleId, option, id) => [
    ...getColumns(t, "my-3"),
    {
        field: 'label',
        label: '',
        className: 'w-100 d-flex align-items-center justify-content-end',
        render: (val, row) => {
            const body = SEARCH_MODEL.setObject({
                page:0,
                size: 20,
                model: option,
                userId: id,
            });
            return row.key === VEHICLE_DETAILS_PROVIDER_SECTION_MODEL.ACCESS_LOG.KEY &&
                <ExportDataBtn
                    moduleId={moduleId}
                    body={body}
                    option={option}
                    search={false}
                    contractorSupplier={false}
                />;
        }},
];

export const DOCUMENTATION_VIEW_MODEL = {
    DOCUMENTATION: 'DOCUMENTATION',
    HISTORY: 'HISTORY',
};
export const DOCUMENTATION_TABS = [
    {
        id: 0,
        key: DOCUMENTATION_VIEW_MODEL.DOCUMENTATION,
        translation: 'documentation',
        icon: <DocumentationIcon className='h-18px w-18px ' />,
    },
    {
        id: 1,
        key: DOCUMENTATION_VIEW_MODEL.HISTORY,
        translation: 'history',
        icon: <IconHistory className='h-18px w-18px' />,
    },
];

export const TRACKING_VIEW = {
    ACCESS_LOG: 'ACCESS_LOG',
    DELIVERY_ENTRANCE: 'DELIVERY_ENTRANCE',
};

export const TRACKING_TABS = [
    {
        id: 0,
        key: TRACKING_VIEW.ACCESS_LOG,
        translation: 'access_log',
        icon: <DocumentPlus className='h-18px w-18px' />,
    },
    {
        id: 1,
        key: TRACKING_VIEW.DELIVERY_ENTRANCE,
        translation: 'delivery_entrance',
        icon: <PersonBook className='h-18px w-18px' />,
    },
];

export const ACCESS_TYPE_MATERIAL_MODEL = {
    ENTRY: {
        ...DEVICE_ACCESS_TYPE_MODEL.ENTRY,
        chipColor:  colors.success100,
        fontColor:  colors.success700
    },
    EXIT: {
        ...DEVICE_ACCESS_TYPE_MODEL.EXIT,
        chipColor:colors.errorCode100,
        fontColor:  colors.errorCode700
    },
    ENTRY_EXIT: {
        ...DEVICE_ACCESS_TYPE_MODEL.ENTRY_EXIT,
         chipColor:  colors.success100 ,
         fontColor:  colors.success700
    }
};

export const CONTRACT_DETAILS_VIEW = {
    EMPLOYEE: 'EMPLOYEE',
    VEHICLE: 'VEHICLE',
};

export const CONTRACT_DETAILS_TABS = [
    {
        id: 0,
        key: CONTRACT_DETAILS_VIEW.EMPLOYEE,
        translation: 'employees',
        icon: <DocumentPlus className='h-18px w-18px' />,
    },
    {
        id: 1,
        key: CONTRACT_DETAILS_VIEW.VEHICLE,
        translation: 'vehicles',
        icon: <PersonBook className='h-18px w-18px' />,
    },
];

export const getCurrentDay = () => {
    const currentDay = new Date();
    currentDay.setHours(0, 0, 0, 0);
    return currentDay;
}


export const STEPS_CONTRACTOR_EMPLOYEE_CREATE = {
    MANAGER_DETAILS: 0,
    OTHER_DETAILS: 1,
    ADD_PHOTO: 2,
    SUMMARY: 3,
};
export const STEPS_CONTRACTOR_EMPLOYEE_CREATE_NO_DETAILS = {
    MANAGER_DETAILS: 0,
    ADD_PHOTO: 1,
    SUMMARY: 2,
};

export const STEPS_CONTRACTOR_EMPLOYEE_UPDATE = {
   MANAGER_DETAILS: 0,
    OTHER_DETAILS: 1,
    ADD_PHOTO: 2,
}
export const STEPS_CONTRACTOR_EMPLOYEE_UPDATE_NO_DETAILS = {
    MANAGER_DETAILS: 0,
    ADD_PHOTO: 1,
}